/**
 * Admin Service - API calls for admin dashboard
 */
import apiClient from '../core/apiClient';

const adminService = {
  /**
   * Check if the current user has admin access
   */
  async checkAdminAccess() {
    try {
      const response = await apiClient.get('/admin/check');
      return response.data;
    } catch (error) {
      if (error.response?.status === 403) {
        return { is_admin: false };
      }
      throw error;
    }
  },

  /**
   * Get global platform statistics
   */
  async getGlobalStats() {
    const response = await apiClient.get('/admin/stats');
    return response.data;
  },

  /**
   * List all users with pagination and filters
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number (default: 1)
   * @param {number} params.page_size - Items per page (default: 50)
   * @param {string} params.search - Search query for email/name/uid
   * @param {boolean} params.paying_only - Filter only paying users
   * @param {string} params.sort_by - Sort field (signup_date, last_login, total_upscale, credits_spent_total)
   * @param {boolean} params.sort_desc - Sort descending
   */
  async listUsers(params = {}) {
    const response = await apiClient.get('/admin/users', { params });
    return response.data;
  },

  /**
   * Get detailed information about a specific user
   * @param {string} userId - The user's Firebase UID
   */
  async getUserDetail(userId) {
    const response = await apiClient.get(`/admin/users/${userId}`);
    return response.data;
  },
};

export default adminService;
